
export const quantityNormalizer = (active) =>
    (value, previousValue, allValues) => {
        const activeCount = allValues[active];
        return value > activeCount ? value : activeCount;
    };
